/**
 * KPP 官网内容 API：GET /api/website/content/
 * 返回 settings、culture_cards、case_studies、service_cards
 */
import axios from 'axios';
import apiBaseUrl from '@/config/api.js';

export function getWebsiteContent() {
  return axios.get(`${apiBaseUrl}/api/website/content/`).then((res) => res.data);
}
